import { css } from '@/styled-system/css';

export const flexStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'inherit',
});
